import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import {
  Container,
  Typography,
  Divider,
  colors
} from '@material-ui/core';
import {
  Page,
  Markdown
} from 'components';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(4, 2, 2, 1)
  },
  divider: {
    backgroundColor: colors.grey[300],
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  markdownContainer: {
    marginLeft: 0,
    marginRight: 0
  }
}));

function GettingStarted() {
  const classes = useStyles();
  const [source, setSource] = useState('');

  useEffect(() => {
    fetch('/docs/GettingStarted.md')
      .then((response) => response.text())
      .then((text) => setSource(text));
  }, []);

  return (
    <Page
      className={classes.root}
      title="Getting Started"
    >
      <Container maxWidth={false}>
        <Typography
          gutterBottom
          variant="overline"
        >
          Getting Started
        </Typography>
        <Divider className={classes.divider} />
      </Container>
      {source && (
        <Container
          maxWidth="md"
          className={classes.markdownContainer}
        >
          <Markdown
            escapeHtml={false}
            source={source}
          />
        </Container>
      )}
    </Page>
  );
}

export default GettingStarted;
